import {Header} from '@/components';

import FeesTab from './FeesTab';

/**
 * Merchant fees screen: the organization-default fee list.
 *
 * Invoices and settlement accounts briefly lived here as tabs; both are now
 * their own entries under Merchants, so this is a single list again. The list
 * body stays in `FeesTab`.
 */
const MerchantFeeList = () => (
  <main className="my-5 mx-4 md:mx-10">
    <Header title="Merchant Fees" dataCy="merchant-fees-title" />
    <div className="mt-5">
      <FeesTab />
    </div>
  </main>
);

export default MerchantFeeList;
